import React from 'react'
import App from './App'
import { createRoot } from 'react-dom/client'

// import './index.scss'
// import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import { store, history, persistor } from './store'
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { createTheme, ThemeProvider, styled } from '@mui/material/styles'
import { HistoryRouter as ReduxHistoryRouter } from 'redux-first-history/rr6';
import { SnackbarProvider } from 'notistack'
import { PersistGate } from 'redux-persist/integration/react'
import _ from 'lodash';

_.templateSettings.interpolate = /{([\s\S]+?)}/g;

const baseTheme = createTheme({
    typography: {
        fontFamily: 'Titillium Web'
    },
})

const theme = createTheme(baseTheme, {
    components: {
        MuiChip: {
            styleOverrides: {
                deleteIcon: {
                    color: baseTheme.palette.primary.main,
                    ":hover": {
                        color: baseTheme.palette.primary.light
                    }
                }
            }
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    // padding: 0,
                    // ">.MuiGrid-item": {
                    //     padding: 0
                    // }
                },
                item: {
                    // padding: 0
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    // "font-weight": "bold"
                }
            }
        }
    }
})

const StatWrapper = styled('div')(
    ({ theme }) => `
    background-color: ${theme.palette.background.paper};
    box-shadow: ${theme.shadows[1]};
    border-radius: ${theme.shape.borderRadius}px;
    padding: ${theme.spacing(2)};
    min-width: 300px;
  `,
);

const Router = ReduxHistoryRouter as any;

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
                <Router history={history} basename={process.env.PUBLIC_URL}>
                    <SnackbarProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <App />
                        </LocalizationProvider>
                    </SnackbarProvider>
                </Router>
            </ThemeProvider>
        </PersistGate>
    </Provider>
)
